// /agents 검색 필드 정의 (SearchToolbar config).
// 기존 인라인 <TextField> 4개를 이 배열 하나로 대체한다.
// field 키 / operator 는 기존 코드와 100% 동일하게 유지한다.

import type { SearchFieldConfig } from "components/list";

export const agentsSearchFields: SearchFieldConfig[] = [
  { name: "id", label: "ID", type: "text", operator: "contains", width: 140 },
  { name: "name", label: "이름", type: "text", operator: "contains", width: 200 },
  { name: "loginId", label: "로그인ID", type: "text", operator: "contains", width: 200 },
  { name: "phoneNumber", label: "전화번호", type: "text", operator: "contains", width: 200 },
];
